// Traduções de mensagens de erro do Firebase Auth para português
export const translateFirebaseError = (errorCode: string): string => {
  const errorTranslations: { [key: string]: string } = {
    // Erros de autenticação
    'auth/invalid-email': 'Email inválido. Verifique o formato do email.',
    'auth/user-disabled': 'Esta conta foi desabilitada. Entre em contato com o suporte.',
    'auth/user-not-found': 'Nenhuma conta encontrada com este email.',
    'auth/wrong-password': 'Senha incorreta. Tente novamente.',
    'auth/invalid-login-credentials': 'Email ou senha incorretos. Verifique suas credenciais.',
    'auth/too-many-requests': 'Muitas tentativas de login. Tente novamente mais tarde.',
    'auth/operation-not-allowed': 'Operação não permitida. Entre em contato com o suporte.',
    'auth/email-already-in-use': 'Este email já está sendo usado por outra conta.',
    'auth/weak-password': 'A senha é muito fraca. Escolha uma senha mais forte.',
    'auth/requires-recent-login': 'Por segurança, faça login novamente para continuar.',
    
    // Erros de reset de senha
    'auth/invalid-action-code': 'Código de recuperação inválido ou expirado.',
    'auth/expired-action-code': 'Código de recuperação expirado. Solicite um novo.',
    'auth/invalid-verification-code': 'Código de verificação inválido.',
    'auth/invalid-verification-id': 'ID de verificação inválido.',
    'auth/missing-verification-code': 'Código de verificação necessário.',
    'auth/missing-verification-id': 'ID de verificação necessário.',
    
    // Erros de rede
    'auth/network-request-failed': 'Erro de conexão. Verifique sua internet.',
    'auth/timeout': 'Tempo limite excedido. Tente novamente.',
    
    // Erros gerais
    'auth/internal-error': 'Erro interno. Tente novamente mais tarde.',
    'auth/unauthorized-domain': 'Domínio não autorizado.',
    'auth/credential-already-in-use': 'Esta credencial já está sendo usada.',
    'auth/invalid-credential': 'Credencial inválida.',
    'auth/account-exists-with-different-credential': 'Já existe uma conta com este email usando outro método de login.',
    'auth/invalid-phone-number': 'Número de telefone inválido.',
    'auth/missing-phone-number': 'Número de telefone necessário.',
    'auth/quota-exceeded': 'Limite de tentativas excedido. Tente novamente mais tarde.',
    'auth/captcha-check-failed': 'Verificação de segurança falhou. Tente novamente.',
    'auth/invalid-app-credential': 'Credencial da aplicação inválida.',
    'auth/missing-app-credential': 'Credencial da aplicação necessária.',
    'auth/invalid-user-token': 'Token de usuário inválido. Faça login novamente.',
    'auth/user-token-expired': 'Sessão expirada. Faça login novamente.',
    'auth/null-user': 'Usuário não encontrado. Faça login novamente.',
    'auth/app-deleted': 'Aplicação foi deletada.',
    'auth/keychain-error': 'Erro de segurança. Tente novamente.',
    'auth/invalid-tenant-id': 'ID do inquilino inválido.',
    'auth/tenant-id-mismatch': 'ID do inquilino não confere.',
    'auth/unsupported-tenant-operation': 'Operação não suportada para este inquilino.',
    'auth/missing-email': 'Email necessário.',
    'auth/missing-password': 'Senha necessária.'
  };

  return errorTranslations[errorCode] || 'Erro desconhecido. Tente novamente.';
};

// Função para extrair o código de erro da mensagem do Firebase
export const extractErrorCode = (errorMessage: string): string => {
  // O Firebase retorna erros no formato "Firebase: Error (auth/error-code)."
  const match = errorMessage.match(/auth\/[a-zA-Z-]+/);
  return match ? match[0] : 'unknown';
};

// Função principal para traduzir erros do Firebase
// utils/errorTranslations.ts
export const translateError = (error: any): string => {
    if (!error?.code) return "Ocorreu um erro inesperado.";
  
    switch (error.code) {
      case "auth/invalid-credential":
      case "auth/invalid-login-credentials":
      case "auth/wrong-password":
        return "E-mail ou senha incorretos.";
  
      case "auth/user-not-found":
        return "Usuário não encontrado. Verifique o e-mail digitado.";
  
      case "auth/email-already-in-use":
        return "Este e-mail já está sendo usado.";
  
      case "auth/invalid-email":
        return "E-mail inválido. Verifique o formato.";
  
      case "auth/too-many-requests":
        return "Muitas tentativas falhadas. Aguarde alguns minutos e tente novamente.";
  
      case "auth/weak-password":
        return "A senha é muito fraca. Use ao menos 6 caracteres.";
  
      default:
        return "Erro inesperado. Tente novamente.";
    }
  };
  